import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import useVisibleCallList from '@modules/SoftPhoneModule/useVisibleCallList';
import { CallBar } from '../CallBar/CallBar';
import useInboxState from '@modules/InboxModule/hooks/useInboxState';
import { useLayoutEffect, useSyncExternalStore } from 'react';
import {
  getCallBarHeight,
  subscribeCallBarHeight,
} from '../CallBar/hooks/callBarHeightRegistry';

const CallBarManager = () => {
  const { callAttributes } = usePhoneState();
  const visibleCallList = useVisibleCallList();
  const { selectedTaskId } = useInboxState();

  // Sole writer of --call-bar-height: CallBarManager reduces every
  // currently-shown CallControls instance's registered height to a single
  // reservation, so no one instance's mount/unmount can race another's.
  // It's normally always mounted (see MainLayout), but sits inside a
  // ModuleErrorBoundary — if it or a descendant throws, the boundary
  // unmounts it and nothing else would ever clear a non-zero reservation.
  // Reset on unmount so a crashed call bar doesn't leave stale bottom
  // padding on page/MFE content with no bar actually rendered.
  const callBarHeight = useSyncExternalStore(
    subscribeCallBarHeight,
    getCallBarHeight,
  );

  useLayoutEffect(() => {
    document.documentElement.style.setProperty(
      '--call-bar-height',
      `${callBarHeight}px`,
    );

    return () => {
      document.documentElement.style.setProperty('--call-bar-height', '0px');
    };
  }, [callBarHeight]);

  const allCallsHeld = visibleCallList.every((call) => call.held);

  return visibleCallList.map((call) => {
    const attributes = {
      ...callAttributes[call.callId],
      queueIds: callAttributes[call.callId]?.queueIds
        ? [...callAttributes[call.callId].queueIds]
        : [],
      traits: callAttributes[call.callId]?.traits
        ? [...callAttributes[call.callId].traits]
        : [],
    };

    // if all calls are held, show the call bar for selected task
    const showSelectedCallBar =
      allCallsHeld &&
      !!selectedTaskId &&
      selectedTaskId === attributes.pcsConversationSid;

    return (
      <CallBar
        key={call.callId}
        callState={call}
        show={!call.held || showSelectedCallBar}
      />
    );
  });
};

export default CallBarManager;
